import FormEmpresa from "components/FormEmpresa";

const CriarEmpresa = () => (
  <div className="card">
    <FormEmpresa />
  </div>
);

export default CriarEmpresa;
